import { Dispatch } from "redux";
import { StartDateActionTypes } from "./types";

export interface StartDateAction {
  type: StartDateActionTypes;
  payload: string;
}

export const startDateActions = {
  addStartDate: (startDate: string) => {
    return (dispatch: Dispatch) => {
      dispatch<StartDateAction>({
        type: StartDateActionTypes.ADD_DATE,
        payload: startDate
      });
    };
  },
  resetDate: () => {
    return (dispatch: Dispatch) => {
      dispatch<StartDateAction>({
        type: StartDateActionTypes.RESET_DATE,
        payload: ""
      });
    };
  }
};
